// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function deepClone<T = unknown>(obj: T, cache = new Map<unknown, any>()): T {
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}

	if (cache.has(obj)) {
		return cache.get(obj);
	}

	if (obj instanceof Date) {
		return new Date(obj.getTime()) as T;
	}

	if (obj instanceof RegExp) {
		return new RegExp(obj.source, obj.flags) as T;
	}

	if (obj instanceof Map) {
		const clonedMap = new Map();
		cache.set(obj, clonedMap);
		for (const [key, value] of obj) {
			clonedMap.set(deepClone(key, cache), deepClone(value, cache));
		}
		return clonedMap as T;
	}

	if (obj instanceof Set) {
		const clonedSet = new Set();
		cache.set(obj, clonedSet);
		for (const value of obj) {
			clonedSet.add(deepClone(value, cache));
		}
		return clonedSet as T;
	}

	if (Array.isArray(obj)) {
		const clonedArray = [];
		cache.set(obj, clonedArray);
		for (let i = 0; i < obj.length; i++) {
			clonedArray[i] = deepClone(obj[i], cache);
		}
		return clonedArray as T;
	}

	if (obj instanceof Object) {
		const clonedObj: { [key: string]: unknown } = {};
		cache.set(obj, clonedObj);
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				clonedObj[key] = deepClone(obj[key], cache);
			}
		}
		return clonedObj as T;
	}

	return obj;
}
